import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../Select/BaseSelectorReadonlyToInput";
import CompanyService from "../../services/CompanyService";

class CompanySelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: 'Empresa',
      label: 'name',
      url: CompanyService.ALL_URL
    };
  }
}

CompanySelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CompanySelector;



// WEBPACK FOOTER //
// ./src/component/Company/CompanySelector.js